<template>
  <Modal v-model="visible" title="跟踪记录内容" width="720" :mask-closable="false">
    <div style="margin-bottom: 12px;">
      <Radio-group v-model="viewMode" type="button" size="small">
        <Radio label="markdown">Markdown</Radio>
        <Radio label="raw" :disabled="!rawText">原文</Radio>
      </Radio-group>
      <span v-if="!rawText" style="margin-left:8px;color:#999;font-size:12px;">无原始内容</span>
    </div>
    <div v-if="viewMode === 'markdown'" ref="contentExportArea" class="track-md track-md-dialog" v-html="html"></div>
    <pre v-else ref="contentExportArea" class="track-raw-dialog">{{ rawText }}</pre>
    <div slot="footer">
      <Button :loading="exportLoading" :disabled="exportLoading || (viewMode==='markdown' ? !html : !rawText)" @click="exportPng">导出 PNG</Button>
      <Button type="primary" @click="visible = false">关闭</Button>
    </div>
  </Modal>
</template>
<script>
import { renderSimpleMarkdown } from '@/utils/simpleMarkdown'
import html2canvas from 'html2canvas'

export default {
  name: 'UserTrackContentModal',
  data () {
    return {
      visible: false,
      html: '',
      rawText: '',
      viewMode: 'markdown',
      meta: {},
      exportLoading: false
    }
  },
  methods: {
    open (item) {
      if (!item || !item.content) {
        this.$Message.warning('暂无内容')
        return
      }
      this.meta = {
        uid: item.uid || '',
        id: item.id || '',
        createTime: item.createTime || ''
      }
      this.html = renderSimpleMarkdown(item.content)
      this.rawText = item.contentRaw || ''
      this.viewMode = 'markdown'
      this.visible = true
    },
    exportPng () {
      let el = this.$refs.contentExportArea
      if (!el || (this.viewMode === 'markdown' ? !this.html : !this.rawText)) {
        this.$Message.warning('暂无内容可导出')
        return
      }
      this.exportLoading = true
      let self = this
      // Modal body / .track-md-dialog 有 max-height+overflow，html2canvas 只会截可见区。
      // 离屏克隆整页高度再截，弹窗内仍可滚动查看。
      let width = Math.max(el.clientWidth || 0, 680)
      let holder = document.createElement('div')
      holder.setAttribute('data-track-png-export', '1')
      holder.style.cssText = 'position:absolute;left:-10000px;top:0;width:' + width + 'px;background:#fff;'
      let clone = el.cloneNode(true)
      clone.className = (el.className || '').replace(/\btrack-md-dialog\b/g, ' ').replace(/\s+/g, ' ').trim()
      if ((' ' + clone.className + ' ').indexOf(' track-md ') < 0) {
        clone.className = (clone.className + ' track-md').trim()
      }
      clone.style.cssText = 'max-height:none!important;overflow:visible!important;height:auto!important;width:' + width + 'px;background:#fff;padding:8px;box-sizing:border-box;'
      holder.appendChild(clone)
      document.body.appendChild(holder)
      let cleanup = function () {
        if (holder && holder.parentNode) {
          holder.parentNode.removeChild(holder)
        }
      }
      void clone.offsetHeight
      let w = Math.max(clone.scrollWidth, width)
      let h = Math.max(clone.scrollHeight, clone.offsetHeight, 1)
      html2canvas(clone, {
        scale: 2,
        backgroundColor: '#ffffff',
        useCORS: true,
        logging: false,
        width: w,
        height: h,
        windowWidth: w,
        windowHeight: h
      }).then(canvas => {
        cleanup()
        let meta = self.meta || {}
        let stamp = String(meta.createTime || '').replace(/[^\d]/g, '')
        let link = document.createElement('a')
        link.download = '跟踪记录_' + (meta.uid || '') + (meta.id ? '_' + meta.id : '') + (stamp ? '_' + stamp : '') + '.png'
        link.href = canvas.toDataURL('image/png')
        link.click()
        self.exportLoading = false
        self.$Message.success('导出成功')
      }).catch(() => {
        cleanup()
        self.exportLoading = false
        self.$Message.error('导出失败')
      })
    }
  }
}
</script>
<style scoped>
.track-md { text-align: left; line-height: 1.5; font-size: 14px; }
.track-raw-dialog {
  max-height: 60vh;
  overflow: auto;
  white-space: pre-wrap;
  word-break: break-word;
  margin: 0;
  padding: 8px;
  background: #fafafa;
  border: 1px solid #eee;
  font-size: 13px;
  line-height: 1.6;
}
.track-md-dialog {
  max-height: 60vh;
  overflow: auto;
  background: #fff;
  padding: 8px 4px;
}
.track-md /deep/ .md-table { border-collapse: collapse; width: 100%; margin: 4px 0; }
.track-md /deep/ .md-table th, .track-md /deep/ .md-table td { border: 1px solid #e8e8e8; padding: 2px 6px; }
.track-md /deep/ h2, .track-md /deep/ h3, .track-md /deep/ h4 { margin: 6px 0 4px; font-size: 14px; }
.track-md /deep/ ul, .track-md /deep/ ol { padding-left: 18px; margin: 4px 0; }
.track-md /deep/ blockquote { margin: 4px 0; padding-left: 8px; border-left: 3px solid #ddd; color: #666; }
.track-md /deep/ p { margin: 2px 0; }
</style>



// WEBPACK FOOTER //
// UserTrackContentModal.vue?5cb8a544